/**
 * Busca tolerante usada nas telas públicas (Transparência, Mapa do Site).
 */

// Sem acento, minúsculo e sem a terminação de plural/singular, para "licitacao" encontrar
// "Licitações" e "servidor" encontrar "Servidores".
const raiz = (palavra) => {
    if (palavra.length <= 3) return palavra
    return palavra
        .replace(/[oa]es$/, 'ao') // licitações → licitacao
        .replace(/([rzl])es$/, '$1') // servidores → servidor
        .replace(/s$/, '') // despesas → despesa
}
const palavrasDaBusca = (texto) => String(texto ?? '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .split(/[^a-z0-9]+/).filter(Boolean).map(raiz)

/**
 * Cada palavra buscada precisa aparecer (no início ou dentro) de alguma palavra do texto.
 *
 * @param {string} texto  onde procurar
 * @param {string} busca  o que o usuário digitou
 */
export function combinaComBusca(texto, busca) {
    const buscadas = palavrasDaBusca(busca)
    if (!buscadas.length) return true
    const doTexto = palavrasDaBusca(texto)
    return buscadas.every(buscada => doTexto.some(palavra => palavra.includes(buscada)))
}
